import { useState } from 'react'

import { BlurApp, Button, Icon } from '@/shared'
import { useDragAndDrop } from '@App/hooks'
import { type ISwapSequencs } from '@App/types/common'
import { EIcons } from '@App/types/iconType'
import {
    type TMainCategoryData,
    type IServiceDec,
    type IChildServiceDec,
    type ICategoryDto
} from '@App/types/servicesTypes'

import { RemoveSectionModal } from './RemoveSectionModal/RemoveSectionModal'
import { SectionItem } from './SectionItem/SectionItem'
import style from './Sections.module.scss'

interface IProps {
    // adminRoles?: IRole[]
    sections: IServiceDec[]
    parentName: string
    parentId: string
    onSwapCategories: (dto: ISwapSequencs) => void
    onSwapServices: (dto: ISwapSequencs) => void
    onGetSectionsRules: (id: string) => void
    onSetTranferSevice: (tranferSevice: IChildServiceDec | null) => void
    setAddSectionId: (addSectionId: string | null) => void
    onRemoveSection: (id: string, onSuccess: () => void) => void
    onEditSection: (dto: ICategoryDto, onSuccess: () => void) => void
    onAddSection: (dto: ICategoryDto, onSuccess: () => void) => void
}

export const Sections = (props: IProps) => {
    const {
        // adminRoles,
        sections,
        parentName,
        parentId,
        onSwapCategories,
        onSwapServices,
        onGetSectionsRules,
        onSetTranferSevice,
        setAddSectionId,
        onRemoveSection,
        onEditSection,
        onAddSection
    } = props

    const [chosenSection, setChosenSection] = useState<string | null>(null)
    const [removableSection, setRemovableSection] = useState<TMainCategoryData | null>(null)
    const [editableSection, setEditableSection] = useState<TMainCategoryData | null>(null)

    const {
        currentItem,
        highlited,
        setHighlited,
        onDragStartHandler,
        onDragLeaveHandler,
        onDragEndHandler,
        onDragOverHandler
    } = useDragAndDrop()

    const onDropHandler = (e: any, item: IServiceDec) => {
        e.preventDefault()
        setHighlited(null)
        if (currentItem && currentItem.id !== item.id) {
            onSwapCategories({ srcId: currentItem.id, destId: item.id })
        }
    }

    return (
        <div className={style.container}>
            <BlurApp show={!!editableSection} />
            {removableSection && (
                <RemoveSectionModal
                    removableSection={removableSection}
                    onClose={() => setRemovableSection(null)}
                    onRemoveSection={onRemoveSection}
                />
            )}
            <div className={style.header}>
                <div className={style.title}>
                    <span>Разделы от &quot;{parentName}&ldquo;</span>
                </div>
                <div className={style.buttons}>
                    <Button className={style.button} onClick={() => setAddSectionId(parentId)}>
                        <div>
                            <Icon iconName={EIcons.PLUS} color='#fff' />
                            <span>Добавить раздел</span>
                        </div>
                    </Button>
                </div>
            </div>
            {sections.map((section) => (
                <SectionItem
                    key={section.id}
                    // adminRoles={adminRoles}
                    onSwapCategories={onSwapCategories}
                    onSwapServices={onSwapServices}
                    item={section}
                    chosenSection={chosenSection}
                    parentId={section.id}
                    onGetSectionsRules={onGetSectionsRules}
                    setChosenSection={setChosenSection}
                    setRemovableSection={setRemovableSection}
                    editableSection={editableSection}
                    setEditableSection={setEditableSection}
                    onSetTranferSevice={onSetTranferSevice}
                    setAddSectionId={setAddSectionId}
                    onRemoveSection={onRemoveSection}
                    onEditSection={onEditSection}
                    onAddSection={onAddSection}
                    onDragEndHandler={onDragEndHandler}
                    onDragLeaveHandler={onDragLeaveHandler}
                    onDragOverHandler={onDragOverHandler}
                    onDragStartHandler={onDragStartHandler}
                    onDropHandler={onDropHandler}
                    highlited={highlited}
                />
            ))}
        </div>
    )
}
